module.exports = __webpack_public_path__ + "static/media/mobiletoggle.5e08114a.png";